import { useBlockProps } from "@wordpress/block-editor";
import React from "react";
import {
	useBlockStyle,
	useClientId,
	useCopyPasteStyles,
	useDeviceType,
} from "../../hooks";
import { EditProps } from "../../types";
import { cn } from "../../utils";
import Breadcrumbs from "./components/Breadcrumbs";
import InspectorControls from "./components/InspectorControls";

const Edit: React.ComponentType<EditProps<any>> = (props) => {
	const {
		attributes: { cssID, className, separator, homeLabel, showHomeLink },
		setAttributes,
	} = props;
	const { clientId } = useClientId(props);
	const { deviceType } = useDeviceType();
	const { CopyPasterStyleBlockControl } = useCopyPasteStyles();
	const { Style } = useBlockStyle({
		blockName: "breadcrumbs",
		clientId,
		attributes: props.attributes,
		deviceType,
	});

	const blockProps = useBlockProps({
		className: cn(`mzb-breadcrumbs mzb-breadcrumbs-${clientId}`, className),
	});

	return (
		<>
			<InspectorControls
				attributes={props.attributes}
				setAttributes={setAttributes}
			/>
			<CopyPasterStyleBlockControl withBlockControls={true} />
			<Style />
			<div {...blockProps} id={cssID}>
				<Breadcrumbs
					separator={separator}
					homeLabel={homeLabel}
					showHomeLink={showHomeLink}
				/>
			</div>
		</>
	);
};

export default Edit;
